import { types } from 'mobx-state-tree';


const VALIDATION_STATES = {
    NOT_STARTED: 'not-started',
    STARTED: 'started',
    COMPLETE: 'complete',
    ERROR: 'error',
};

const ValidationStateEnum = types.enumeration('ValidationState', Object.values(VALIDATION_STATES));

export {
    ValidationStateEnum,
};
export default VALIDATION_STATES;
